import { useEffect, useState } from "react";
import axios from "axios";
import LightAdmin from "components/headers/lightAdmin";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/Footer.jsx";
import ReactPaginate from "react-paginate";
import './style.css';
import { useTranslation } from 'react-i18next';
const Retraite = () => {
        const { t } = useTranslation();
    const [withdrawals, setWithdrawals] = useState([]);
    const [currentPage, setCurrentPage] = useState(0); // Track the current page
    const [totalPages, setTotalPages] = useState(0); // Total pages for pagination
    const token = localStorage.getItem("authToken");
const [searchTerm, setSearchTerm] = useState("");
const [statusFilter, setStatusFilter] = useState("all");

    useEffect(() => {
        fetchWithdrawals();
    }, [currentPage]); // Fetch withdrawals when page changes
console.log(withdrawals);
    if (!token) {
        console.error("JWT token not found");
        return;
    }

    const fetchWithdrawals = async () => {
        try {
            const response = await axios.get(`  https://rehabwmg.online/api/withdrawals?page=${currentPage + 1}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.status === 200) {
                setWithdrawals(response.data.data); // Assuming data is in 'data' field
                setTotalPages(response.data.total_pages); // Assuming total pages are returned in 'total_pages'
            } else {
                console.error("Failed to fetch withdrawals:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching withdrawals:", error);
        }
    };

    const approveWithdrawal = async (id, role) => {
        try {
            let url = '';
            let method = '';
    
            // Define URL and HTTP method based on the role
            if (role === 'buyer') {
                url = `  https://rehabwmg.online/api/admin/buyer/approve-withdrawal/${id}`;
                method = 'PUT';  // Use PUT for buyers
            } else {
                url = `  https://rehabwmg.online/api/admin/withdrawals/${id}/approve`;
                method = 'POST';  // Use POST for suppliers
            }
    
            const response = await axios({
                method: method, // Use dynamic method
                url: url,
                headers: { Authorization: `Bearer ${token}` },
            });
    
            if (response.status === 200) {
                fetchWithdrawals(); // Refresh withdrawals after approval
            } else {
                console.error("Échec de l'approbation :", response.statusText);
            }
        } catch (error) {
            console.error("Erreur lors de l'approbation :", error);
        }
    };

    // Handle page change for pagination
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };
const filteredWithdrawals = withdrawals.filter((withdrawal) => {
  const name = withdrawal.user?.name?.toLowerCase() || "";
  const customId = withdrawal.user?.custom_id?.toLowerCase() || "";
  const status = withdrawal.status?.toLowerCase() || "";
  const term = searchTerm.toLowerCase();

  const matchesSearch = name.includes(term) || customId.includes(term);
  const matchesStatus =
    statusFilter === "all" || status === statusFilter.toLowerCase();

  return matchesSearch && matchesStatus;
});

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex flex-column">
                <section className="w-100 p-3">
                     <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                        <h1 className="text-dark display-4">{t('Tableau_de_bord_Retraite')}</h1>
    <input
        type="text"
        className="form-control w-auto"
  placeholder={t('Rechercher_par_nom_id')}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        
        style={{ maxWidth: '300px' }}
    />
    <select
  className="form-control"
  style={{ maxWidth: '200px' }}
  value={statusFilter}
  onChange={(e) => setStatusFilter(e.target.value)}
>
  <option value="all">{t('Tous_les_statuts')}</option>
  <option value="en attente">{t('en_attente')}</option>
  <option value="approuvé">{t('approuvé')}</option>
</select>

</div>
                    <hr className="my-4" />

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead className="table-primary">
                                <tr>
                                    <th>{t('Utilisateur')}</th>
                                    <th>{t('Nom')}</th>
                                    <th>{t('Téléphone')}</th>
                                    <th>{t('amount')}</th>
                                    <th>{t('statut')}</th>
                                    <th>{t('DateC')}</th>
                                    <th>{t('')}</th>
                                    <th>{t('DateV')}</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredWithdrawals.map((w) => (
                                    <tr key={w.id}>
                                        <td>{w.user?.custom_id || "N/A"}</td>
    <td>{w.user?.name || "N/A"}</td>
    <td>{w.user?.phone || "N/A"}</td>
                                        <td>{w.amount} {t("currency")}</td>
<td>{t(w.status)}</td>

<td>
  {w.created_at
    ? new Date(w.created_at).getFullYear() + "-" +
      String(new Date(w.created_at).getMonth() + 1).padStart(2, "0") + "-" +
      String(new Date(w.created_at).getDate()).padStart(2, "0") + " " +
      String(new Date(w.created_at).getHours()).padStart(2, "0") + ":" +
      String(new Date(w.created_at).getMinutes()).padStart(2, "0")
    : ""}
</td>
                                        <td>
                                            {w.status === "en attente" && (
                                                <button 
                                                    onClick={() => approveWithdrawal(w.id, w.user.role)} 
                                                    className="btn btn-success">
                                                    {t('Approuver')}
                                                </button>
                                            )}
                                        </td>
<td>
  {w.updated_at    
? new Date(w.created_at).getFullYear() + "-" +
      String(new Date(w.created_at).getMonth() + 1).padStart(2, "0") + "-" +
      String(new Date(w.created_at).getDate()).padStart(2, "0") + " " +
      String(new Date(w.created_at).getHours()).padStart(2, "0") + ":" +
      String(new Date(w.created_at).getMinutes()).padStart(2, "0")
    : ""}
</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                <li className="page-item" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                                    <button className="page-link">{t('Previous')}</button>
                                </li>
                                {[...Array(totalPages)].map((_, index) => (
                                    <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                                            {index + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className="page-item" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                                    <button className="page-link">{t('Next')}</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default Retraite;
